var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/file-alt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/file-alt",
    stroke: "none",
    strokeWidth: 1,
    fill: "inherit",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,11.625 L16.5,12.9375 C16.5,13.246875 16.246875,13.5 15.9375,13.5 L8.06249998,13.5 C7.75312498,13.5 7.49999998,13.246875 7.49999998,12.9375 L7.49999998,11.625 C7.49999998,11.315625 7.75312498,11.0625 8.06249998,11.0625 L15.9375,11.0625 C16.246875,11.0625 16.5,11.315625 16.5,11.625 Z M15.9375,15 L8.06249998,15 C7.75312498,15 7.49999998,15.253125 7.49999998,15.5625 L7.49999998,16.875 C7.49999998,17.184375 7.75312498,17.4375 8.06249998,17.4375 L15.9375,17.4375 C16.246875,17.4375 16.5,17.184375 16.5,16.875 L16.5,15.5625 C16.5,15.253125 16.246875,15 15.9375,15 Z M21,6.18281248 L21,21.75 C21,22.9921875 19.9921875,23.9999999 18.75,23.9999999 L5.24999997,23.9999999 C4.00781247,23.9999999 2.99999996,22.9921875 2.99999996,21.75 L2.99999996,2.24999996 C2.99999996,1.00781245 4.00781247,-5.00000006e-08 5.24999997,-5.00000006e-08 L14.8171875,-5.00000006e-08 C15.4125,-5.00000006e-08 15.984375,0.239062451 16.40625,0.660937453 L20.3390625,4.59374997 C20.7609375,5.01093747 21,5.58749997 21,6.18281248 Z M15,2.43281246 L15,5.99999997 L18.5671875,5.99999997 L15,2.43281246 Z M18.75,21.75 L18.75,8.24999996 L13.875,8.24999996 C13.2515625,8.24999996 12.75,7.74843748 12.75,7.12499998 L12.75,2.24999996 L5.24999997,2.24999996 L5.24999997,21.75 L18.75,21.75 Z",
    id: "file-alt",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.8721fa48d3baad429daff00a5522d2d5.svg";
export { ForwardRef as ReactComponent };